export default {"src":"/trader-new/_next/static/media/ReferAndEarn.c7736707.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};